import type {
  DatasetManifestEntry,
  ReportDefinition,
} from '../types/reporting';

/** Whether the definition uses the persisted explicit-selection contract. */
export function usesCustomDetailColumns(def: ReportDefinition): boolean {
  return def.detail_columns_mode === 'custom';
}

/**
 * Legacy empty lists and v3 `all` both emit every primary dataset column. A v3
 * custom list is always literal, including an intentional empty list.
 */
export function effectiveDetailColumns(
  def: ReportDefinition,
  dataset: DatasetManifestEntry
): string[] {
  return usesCustomDetailColumns(def)
    ? def.columns
    : def.columns.length > 0
      ? def.columns
      : dataset.columns.map(column => column.name);
}

export function hasCustomEmptyDetailColumns(def: ReportDefinition): boolean {
  return usesCustomDetailColumns(def) && def.columns.length === 0;
}

/**
 * Any user edit to detail columns becomes an explicit v3 selection. This keeps
 * a deliberately empty list distinct from the legacy all-primary shorthand.
 */
export function withCustomDetailColumns(
  def: ReportDefinition,
  columns: string[]
): ReportDefinition {
  return {
    ...def,
    schema_version: 3,
    detail_columns_mode: 'custom',
    columns,
  };
}
